import { createFileRoute } from '@tanstack/react-router';

type SearchParams = {
  updateList?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/payments/payment-plans')({
  staticData: {
    team: 'payments',
  },
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    return search;
  },
});
